import React, {useState} from 'react';
import {ActsItems} from "./acts-items/Acts-items";
import {ActsCol} from "./acts-col/Acts-col";
import {LittleSelector} from "./little-selector/Little-selector";

import {useAppDispatch, useAppSelector} from "common/hook";
import {CustomPagination} from "../../../pagination/CustomPagination";
import {fetchActs} from "features/model/service/payments/acts/fetchActs";
import {Preloader} from "../../../layout/preloader/Preloader";
import {Act, Period} from "features/model/types/payments/actsSchema";
import {NothingYetMessage} from "../../personal-cabinet/nothing-yet-message/NothingYetMessage";



export const ActsTable: React.FC = () => {
    const dispatch = useAppDispatch();
    const actsState = useAppSelector((state) => state.acts);
    const {items, periods, pagination, error, isLoading} = actsState;
    const {pageSize,pageCount,page} = pagination

    const periodsOptions: Period[] = (periods || []).map(period => ({
        value: period.value,
        label: period.label,
    }));


    const onChangeHandle = (event: React.ChangeEvent<unknown>, value: number) => {
        dispatch(fetchActs({page: value -1}));
    };


    return (
        <div className="tabs-content">
            <div className="tab">
                <div className="data-tbl-controls">
                    <LittleSelector
                        title={'Период'}
                        options={periodsOptions}
                    />
                </div>

                <div className="data-tbl payments-tbl has-print">
                    <ActsCol/>
                    {isLoading ? (
                        <Preloader />
                    ) : items && items.length > 0 ? (
                        items.map((act: Act) => (
                            <ActsItems key={act.id} acts={act} />
                        ))
                    ) : (
                        <NothingYetMessage />
                    )}
                    {pageCount > 1 && (
                        <CustomPagination pageCount={pageCount} onChangeHandle={onChangeHandle} />
                    )}
                </div>
            </div>
        </div>
    );
};

